import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import { emailAndPhoneOptions } from '../../helper';
import { gray } from '../../theme/themePrimitives';
import LabelWrapper from '../wrapper/label';
import { LeadObject } from '../../params/redux/leads';
import { SendBulkEmailsParams } from '../../params/redux/email';
import { sendBulkSMSThunk } from '../../redux/thunks/sms';
import { settingBulkMessageFlag } from '../../redux/slices/leads';
import { smsMessageComposeSchema } from '../../schema/sms_schema';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Chip, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { KeyboardArrowLeftRounded, Sms } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const SMSBulkComposeComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const { bulkMessage, leads } = useSelector((state: RootState) => state.lead);
    const { loaders } = useSelector((state: RootState) => state.sms);
    const [selectedNumbers, setSelectedNumbers] = useState<string[]>([]);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);

    useEffect(() => {
        if (bulkMessage.selectedRows.length) {
            const selectedleads: LeadObject[] = leads.filter((lead: LeadObject) => bulkMessage.selectedRows.includes(lead.id));
            const numbers = selectedleads.filter((lead) => lead.phone && lead.phone !== '').map((lead: LeadObject) => lead.phone);
            const ids = selectedleads.filter((lead) => lead.phone && lead.phone !== '').map((lead: LeadObject) => lead.id);
            setSelectedIds(ids);
            setSelectedNumbers(numbers as string[]);
        }
    }, []);


    // const handleRemoveNumber = (number: string) => {
    //     setSelectedNumbers(selectedNumbers.filter((e) => e !== number));
    // };

    const navigateBackHandler = () => {
        dispatch(settingBulkMessageFlag({
            type: null,
            rows: []
        }));
    };

    const composeSMSHandler = async (values: {
        message: string;
    }) => {
        try {
            const data: SendBulkEmailsParams = {
                message: values.message,
                data: selectedIds,
                client_id: id ? parseInt(id as string, 10) : 0
            };
            await dispatch(sendBulkSMSThunk(data)).unwrap();
            navigateBackHandler();
        } catch (e) {
            //
        }
    };

    return (
        <Formik
            initialValues={{
                to: 'yooo',
                message: ''
            }}
            validationSchema={smsMessageComposeSchema}
            onSubmit={composeSMSHandler}
        >
            {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => (<Form>
                <Box display="flex" flexDirection="column" gap={2}>
                    <Box display="flex" justifyContent="space-between">
                        <Button startIcon={<KeyboardArrowLeftRounded />} variant="text" color="secondary" disabled={loaders.isCreating} onClick={navigateBackHandler}>Back</Button>
                        <Typography variant="h4" color="textSecondary">Send SMS</Typography>
                        <Box></Box>
                    </Box>
                    <Box>
                        <LabelWrapper label="To:" />
                        <Box
                            p={1}
                            border={`1px solid ${gray[300]}`}
                            borderRadius={1}
                            display="flex"
                            alignItems="center"
                            flexWrap="wrap"
                            gap={1}
                        >
                            {selectedNumbers.length === 0
                                ? (<Typography color="gray">No Numbers selected</Typography>)
                                : (
                                    selectedNumbers.filter((number) => number !== '').map((number) => (
                                        <Chip
                                            key={number}
                                            label={number}
                                            // onDelete={() => handleRemoveNumber(number)}
                                            deleteIcon={<Sms />}
                                            color="primary"
                                            variant="outlined"
                                            sx={{
                                                padding: '15px 0',
                                                borderRadius: '5px'
                                            }}
                                        />
                                    ))
                                )}
                        </Box>
                    </Box>

                    <Box display="flex" flexDirection="column" gap={2}>
                        <Box display="flex" justifyContent="space-between" alignItems="end">
                            <LabelWrapper label="Message:" />
                            <Box>
                                <CustomDropdown
                                    options={emailAndPhoneOptions}
                                    value=""
                                    placeholder="Add Field"
                                    disabled={loaders.isCreating}
                                    onChange={(e) => setFieldValue('message', `${values.message} [${e.target.value}]`)}
                                    sx={{
                                        marginBottom: 0
                                    }}
                                />
                            </Box>
                        </Box>
                        <CustomInput
                            type="textarea"
                            row={8}
                            placeholder="Type Here..."
                            value={values.message}
                            error={errors.message && touched.message}
                            onChange={handleChange('message')}
                            onBlur={handleBlur('message')}
                            disabled={loaders.isCreating}
                            fullWidth
                        />
                    </Box>
                    <Box display="flex" justifyContent="end" alignItems="center" gap={2}>
                        <Button variant="outlined" color="secondary" disabled={loaders.isCreating} size="large" onClick={navigateBackHandler}>Cancel</Button>
                        <Button type="submit" variant="contained" disabled={loaders.isCreating} size="large">Send</Button>
                    </Box>
                </Box>
            </Form>
            )}
        </Formik>
    );
};

export default SMSBulkComposeComponent;